import { Injectable, ErrorHandler } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';

@Injectable()
export class ChunkErrorHandler implements ErrorHandler {
  constructor(private snackbar: MatSnackBar) {}
  handleError(error: any) {
    if (error instanceof Error && error.message.match(/Loading chunk/i)) {
      const ref = this.snackbar.open('Glimpse has been updated, please reload the page!', 'Reload', {
        duration: 60 * 1000,
      });

      ref.onAction().subscribe(() => {
        window.location.reload();
      });
    } else {
      throw error;
    }
  }
}
